import axios from "axios";
import jsonFormData from "json-form-data";

const prepareData = (data) => jsonFormData({ project_drawing_office_iff: data }, { showLeafArrayIndexes: false });

// Plural Actions
export const GET_PROJECT_DRAWING_OFFICE_IFFS = "get_project_drawing_office_iffs";
export const getProjectDrawingOfficeIffs = (project_id) => {
	const url = `/project/${project_id}/drawing_office/iffs.json`
	const request = axios.get(url);
	return {
		type: GET_PROJECT_DRAWING_OFFICE_IFFS,
		payload: request
	};
};


// Singular Actions
export const CREATE_PROJECT_DRAWING_OFFICE_IFF = "create_project_drawing_office_iff";
export const createProjectDrawingOfficeIff = (project_id,data) => {
	const url = `/project/${project_id}/drawing_office/iffs.json`
	const request = axios({method: "post",url: url,data: prepareData(data)});
	return {
		type: CREATE_PROJECT_DRAWING_OFFICE_IFF,
		payload: request
	};
};

export const GET_PROJECT_DRAWING_OFFICE_IFF = "get_project_drawing_office_iff";
export const getProjectDrawingOfficeIff = (project_id,id) => {
	const url = `/project/${project_id}/drawing_office/iffs/${id}.json`
	const request = axios.get(url);
	return {
		type: GET_PROJECT_DRAWING_OFFICE_IFF,
		payload: request
	};
};

export const UPDATE_PROJECT_DRAWING_OFFICE_IFF = "update_project_drawing_office_iff";
export const updateProjectDrawingOfficeIff = (project_id,id,data) => {
	const url = `/project/${project_id}/drawing_office/iffs/${id}.json`
	const request = axios({method: "patch",url: url,data: prepareData(data)});
	return {
		type: UPDATE_PROJECT_DRAWING_OFFICE_IFF,
		payload: request
	};
};

export const DESTROY_PROJECT_DRAWING_OFFICE_IFF = "destroy_project_drawing_office_iff";
export const destroyProjectDrawingOfficeIff = (project_id,id) => {
	const url = `/project/${project_id}/drawing_office/iffs/${id}.json`
	const request = axios({method: "delete",url: url});
	return {
		type: DESTROY_PROJECT_DRAWING_OFFICE_IFF,
		payload: request
	};
};

// Compare two stored IFF CSVs (base = previous, head = current). Returns the axios promise.
export const compareProjectDrawingOfficeIffs = (project_id, { base_id, head_id }) => {
	const url = `/project/${project_id}/drawing_office/iffs/compare.json`;
	return axios.get(url, { params: { base_id, head_id } });
};
